<template>
    <div>
        <el-select
            v-if="multiple"
            v-model="selectTemplate"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入关键词"
            :multiple="true"
            :remote-method="queryApprovalTemplateList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in ApprovalTemplateList"
                :key="item.id"
                :label="item.templateName"
                :value="item.id">
            </el-option>
        </el-select>

        <el-select
            v-else
            v-model="selectProcess"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="queryApprovalTemplateList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in ApprovalTemplateList"
                :key="item.id"
                :label="item.templateName"
                :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import { getApprovalTemplateList } from '@/data-model';

    export default {
        data () {
            return {
                loading: false,
                ApprovalTemplateList: [],
                selectTemplate: [],
                mutilProcesss: '',
                selected: {
                    id: '',
                    templateName: ''
                },
                selectProcess: ''
            };
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            formData: {
                type: Object,
                required: true
            },
            multiple: {
                type: Boolean,
                required: false
            }
        },
        created () {
            this.queryApprovalTemplateList('');
        },
        methods: {
            async queryApprovalTemplateList (templateName) {
                this.loading = true;
                let { data } = await getApprovalTemplateList({
                    pageSize: 500,
                    currentPage: 1,
                    templateName: templateName,
                    templateState: 1
                });
                this.ApprovalTemplateList = data;
                this.loading = false;
            },
            selectTrigger (val) {
                if (this.multiple) {
                    if (this.formData) {
                        if (val) {
                            let templateNames = [];
                            this.ApprovalTemplateList.find((item) => {
                                val.find((it) => {
                                    if (item.id === it) {
                                        templateNames.push(item.templateName);
                                    }
                                });
                            });
                            this.formData[this.field.formField] = val.join(',');
                            this.formData[this.field.formField + '-ApprovalTemplate'] = templateNames.join(',');
                        } else {
                            this.ApprovalTemplateList = [];
                            this.formData[this.field.formField] = '';
                            this.formData[this.field.formField + '-ApprovalTemplate'] = '';
                        }
                    }
                } else {
                    if (val) {
                        this.selected = this.ApprovalTemplateList.find((item) => {
                            return item.id === val;
                        });
                    } else {
                        this.selected = {id: '', templateName: ''};
                    }
                    if (this.formData) {
                        this.formData[this.field.formField] = this.selected.idd;
                        this.formData[this.field.formField + '-ApprovalTemplate'] = this.selected.templateName;
                    }
                }
                this.$emit('nodeClick', {id: this.selected.id, label: this.selected.templateName});
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ApprovalTemplateSelectPop/ApprovalTemplateSelectPop.vue